import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import hospitalroom from "../../assets/images/icons/hospital-room.png";
import patientreg from "../../assets/images/icons/patientreg.png";
import admission from "../../assets/images/icons/admission.png";
import admissionreport from "../../assets/images/icons/admissionreport.png";
import patient from "../../assets/images/icons/patient.png";
import customer from "../../assets/images/icons/customercare.png";
import payment from "../../assets/images/icons/payment.png";
import inventory from "../../assets/images/inventory.jpg";
import volunteers from "../../assets/images/icons/volunteer.png";
import dialysis from "../../assets/images/icons/dialysis.png";
import discharge from "../../assets/images/discharge.jpg";
import PhysioSvg from "../PhysioTherappy/Physiosvg";
import PalliativeSvg from "../Palliative/palliativesvg";
import cirtificate from "../../assets/images/icons/report.png";
import calendar from "../../assets/images/icons/calendar3.png";
import wound from "../../assets/images/wound.png";
import appointment from "../../assets/images/appointment.png";
import visitor from "../../assets/images/icons/visitor.png";
import Notificationbadge from "../common/Notificationbadge";
import { MdRestaurantMenu } from 'react-icons/md';
function RenderTiles({ access }) {
    const role = sessionStorage.getItem("usertype");
    const features = sessionStorage.getItem("features");
    const [DiaCount, setDiaCount] = useState(0);
    const [PhyCount, setPhyCount] = useState(0);
    const [PalCount, setPalCount] = useState(0);
    const navigate = useNavigate();
    return (
        <div className="home-container">
            <Notificationbadge setDiaCount={setDiaCount} setPalCount={setPalCount} setPhyCount={setPhyCount} />
            {(access.some(item => item.node_access === "0.1.6") && (role === 'hospital_bdo' || role === 'hospital_pro')) && (
                <div className="home-tiles" onClick={() => navigate("/admission")}>
                    <img src={admission} className="home-icon" width="65px" alt="Admissions" />
                    <h5 className="each-title">Admissions</h5>
                </div>
            )}
            {(access.some(item => item.node_access === "0.1.5") && (role === 'hospital_bdo' || role === 'hospital_pro')) && (
                <div className="home-tiles" onClick={() => navigate("/admissionreport")}>
                    <img src={admissionreport} className="home-icon" width="65px" alt="Reports" />
                    <h5 className="each-title">Reports</h5>
                </div>
            )}
            {(access.some(item => item.node_access === "0.1.14") && (role === 'hospital_bdo' || role === 'hospital_pro' || role === 'hospital_allied_prof' || role === 'hospital_nurse')) && (
                <div className="home-tiles" onClick={() => navigate("/death_report")}>
                    <img src={cirtificate} className="home-icon" width="65px" alt="Reports" />
                    <h5 className="each-title">Death Reports</h5>
                </div>
            )}
            {(access.some(item => item.node_access === "0.1.4") && (role === 'hospital_bdo' || role === 'hospital_pro' || role === 'hospital_doctor' || role === 'hospital_allied_prof' || role === 'hospital_nurse')) && (
                <div className="home-tiles" onClick={() => navigate("/patientlist")}>
                    <img src={patient} className="home-icon" width="65px" alt="Patient Records" />
                    <h5 className="each-title">Patient Records</h5>
                </div>
            )}
            {(access.some(item => ["0.1.7.2", "0.1.7"].includes(item.node_access)) && (role === 'hospital_bdo' || role === 'hospital_pro')) && (
                <div className="home-tiles" onClick={() => navigate("/assignpatient")}>
                    <img src={hospitalroom} className="home-icon" width="65px" alt="Facility Assignments" />
                    <h5 className="each-title">Facility Assignments</h5>
                </div>
            )}
            {(access.some(item => ["0.1.1.4", "0.1.2.4", "0.1.3.4", "0.1.8.3"].includes(item.node_access)) && (role === 'hospital_bdo' || role === 'hospital_front_office' || role === 'hospital_nurse' || role === 'hospital_allied_prof')) && (
                <div className="home-tiles" onClick={() => navigate("/customercare")}>
                    <img src={customer} className="home-icon" width="65px" alt="Customer Service Centre" />
                    <h6 className="each-title">Customer Service Centre</h6>
                </div>
            )}
            {(access.some(item => ["0.1.1.2", "0.1.2.2", "0.1.3.2", "0.1.8.1"].includes(item.node_access)) && (role === 'hospital_doctor' || role === 'hospital_allied_prof')) && (
                <div className="home-tiles" onClick={() => navigate("/appointments")}>
                    <img src={appointment} className="home-icon" width="55px" alt="appointment" />
                    <h6 className="each-title">Appointments</h6>
                </div>
            )}
            {/* {(access.some(item => ["0.1.13.2"].includes(item.node_access)) && (role === 'hospital_bdo' || role === 'hospital_pro')) && (
                <div className="home-tiles" onClick={() => navigate("/feedback")}>
                    <img src={feedback} className="home-icon" width="65px" alt="feedback" />
                    <h5 className="each-title">Customer feedback</h5>
                </div>
            )} */}
            {(access.some(item => ["0.1.8.2"].includes(item.node_access)) && (role === 'hospital_bdo')) && (
                <div className="home-tiles" onClick={() => navigate("/register-patient")}>
                    <img src={patientreg} className="home-icon" width="65px" alt="patinet registration" />
                    <h5 className="each-title">Patient registration</h5>
                </div>
            )}
            {(access.some(item => item.node_access === "0.1.12") && (role === 'hospital_bdo' || role === 'hospital_pro')) && (
                <div className="home-tiles" onClick={() => navigate("/payment")}>
                    <img src={payment} className="home-icon" width="65px" alt="Payment" />
                    <h6 className="each-title">Payment</h6>
                </div>
            )}
            {/* {(access.some(item => ["0.1.13.2"].includes(item.node_access)) && (role === 'hospital_bdo' || role === 'hospital_pro')) && (
                <div className="home-tiles" onClick={() => navigate("/service_request")}>
                    <img src={request} className="home-icon" width="65px" alt="Service Fulfillment" />
                    <h5 className="each-title">Service Fulfillment</h5>
                </div>
            )} */}
            {(access.some(item => ["0.1.6.2"].includes(item.node_access)) && (role === 'hospital_bdo' || role === 'hospital_pro')) && (
                <div className="home-tiles" onClick={() => navigate("/personal-inventory")}>
                    <img src={inventory} className="home-icon" width="65px" alt="Personal Inventory" />
                    <h6 className="each-title">Personal Inventory</h6>
                </div>
            )}
            {(role === 'hospital_bdo' || role === 'hospital_pro') && <div className="home-tiles"
                onClick={() => navigate("/visitor_requests")}
            >
                <img src={visitor} alt="" className="home-icon" width="65px" />
                <h5 className="each-title"> Visitors
                </h5>

            </div>}
            {(access.some(item => item.node_access === "0.1.9") && (role === 'hospital_bdo' || role === 'hospital_pro')) && (
                <div className="home-tiles" onClick={() => navigate("/volunteers")}>
                    <img src={volunteers} className="home-icon" width="65px" alt="Volunteers" />
                    <h5 className="each-title">Volunteers</h5>
                </div>
            )}
            {(access.some(item => ["0.1.1.1", "0.1.1.3", "0.1.7.3", "0.1.10.13"].includes(item.node_access)) && (role === 'hospital_bdo' || role === 'hospital_pro' || role === 'hospital_front_office' || role === 'hospital_nurse')) && (
                <div className="home-tiles" onClick={() => {
                    navigate("/dialysis");
                }}>
                    <div className="icon-wrapper">
                        <img src={dialysis} className="home-icon" alt="Dialysis" />
                        {(role === 'hospital_bdo' || role === 'hospital_pro') && DiaCount > 0 && (
                            <span className="notification-badge">{DiaCount}</span>
                        )}
                    </div>
                    <h5 className="each-title">Dialysis</h5>
                </div>

            )}
            {(access.some(item => ["0.1.3.1", "0.1.3.3", "0.1.10.11"].includes(item.node_access)) && (role === 'hospital_bdo' || role === 'hospital_pro' || role === 'hospital_front_office' || role === 'hospital_allied_prof')) && (
                <div className="home-tiles" onClick={() => {

                    navigate("/Phys");
                }}>
                    <div className="icon-wrapper">
                        <div className="home-icon" style={{ display: 'flex', alignItems: 'center' }} width="65px">
                            <PhysioSvg />
                        </div>
                        {(role === 'hospital_bdo' || role === 'hospital_pro') && PhyCount > 0 && (
                            <span className="notification-badge">{PhyCount}</span>
                        )}
                    </div>
                    <h5 className="each-title">Physiotherapy Unit</h5>
                </div>
            )}
            {(access.some(item => ["0.1.2.1", "0.1.2.3"].includes(item.node_access)) && (role === 'hospital_bdo' || role === 'hospital_pro' || role === 'hospital_front_office' || role === 'hospital_nurse')) && (
                <div className="home-tiles" onClick={() => {
                    navigate("/palliative");
                }}>
                    <div className="icon-wrapper">
                        <div className="home-icon" style={{ display: 'flex', alignItems: 'center' }} width="65px">
                            <PalliativeSvg />
                        </div>
                        {(role === 'hospital_bdo' || role === 'hospital_pro') && PalCount > 0 && (
                            <span className="notification-badge">{PalCount}</span>
                        )}
                    </div>
                    <h5 className="each-title">Palliative Care</h5>
                </div>
            )}
            {/* {(access.some(item => item.node_access === "0.1.8") && (role === 'hospital_pro')) && (
                <div className="home-tiles" onClick={() => navigate("/selected-services")}>
                    <img src={sda} className="home-icon" width="65px" alt="Services" />
                    <h5 className="each-title">Services</h5>
                </div>
            )} */}
            {(access.some(item => item.node_access === "0.1.10.12") && (role === 'hospital_doctor')) && (
                <div className="home-tiles" onClick={() => navigate("/doctor_schedule")}>
                    <img src={calendar} alt="" className="home-icon" width="65px" />
                    <h5 className="each-title">Schedule</h5>
                </div>
            )}
            {(access.some(item => item.node_access === "0.1.16") && (role === 'hospital_bdo' || role === 'hospital_pro' || role === 'hospital_allied_prof' || role === 'hospital_nurse')) && (
                <div className="home-tiles" onClick={() => navigate("/discharge")}>
                    <img src={discharge} alt="" className="home-icon" width="65px" />
                    <h5 className="each-title">Discharge</h5>
                </div>
            )}
            {(access.some(item => ["0.1.4.1"].includes(item.node_access)) && (role === 'hospital_doctor' || role === 'hospital_nurse' || role === 'hospital_allied_prof')) && (
                <div className="home-tiles" onClick={() => navigate("/wound_chart")}>
                    <img src={wound} alt="" className="home-icon" width="65px" />
                    <h5 className="each-title">Wound Documentation</h5>
                </div>
            )}
            {role === 'hospital_bdo' && (
                <div className="home-tiles" onClick={() => navigate("/house_keeping")}>
                    <img src={wound} alt="" className="home-icon" width="65px" />
                    <h5 className="each-title">House Keeping</h5>
                </div>
            )}
            {role === 'hospital_bdo' &&
                <div className="home-tiles" onClick={() => navigate("/nurse-roster")}>
                    <img src={customer} alt="" className="home-icon" width="65px" />
                    <h5 className="each-title">Roster Basic</h5>
                </div>}
            {(role === 'hospital_bdo') &&
                <div className="home-tiles" onClick={() => navigate("/nurse-roster1")}>
                    <img src={customer} alt="" className="home-icon" width="65px" />
                    <h5 className="each-title">Roster</h5>
                </div>}
            {(role === 'hospital_bdo') &&
                <div className="home-tiles" onClick={() => navigate("/kitchen")}>
                    <div className="icon-wrapper">
                        <div className="home-icon" style={{ display: 'flex', alignItems: 'center', color: '#2b69a3' }} width="65px">
                            <MdRestaurantMenu />
                        </div>
                    </div>
                    <h5 className="each-title">Kitchen</h5>
                </div>}
            {(role === 'hospital_nurse' && features.includes("roster") && access.some(item => item.node_access === "0.1.17")) &&
                <div className="home-tiles" onClick={() => navigate("/leaverequests")}>
                    <img src={customer} alt=""
                        className="home-icon" width="65px" />
                    <h5 className="each-title">Roster</h5>
                </div>}
        </div>
    );
};
export default RenderTiles